// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnimalPreferencesController from "./animal_preferences_controller"
application.register("animal-preferences", AnimalPreferencesController)

import BookingWizardActionBarController from "./booking_wizard_action_bar_controller"
application.register("booking-wizard-action-bar", BookingWizardActionBarController)

import BookingWizardAddonController from "./booking_wizard_addon_controller"
application.register("booking-wizard-addon", BookingWizardAddonController)

import BookingWizardLocationController from "./booking_wizard_location_controller"
application.register("booking-wizard-location", BookingWizardLocationController)

import BookingWizardPetsController from "./booking_wizard_pets_controller"
application.register("booking-wizard-pets", BookingWizardPetsController)

import BookingWizardPreviewController from "./booking_wizard_preview_controller"
application.register("booking-wizard-preview", BookingWizardPreviewController)

import BookingWizardResendController from "./booking_wizard_resend_controller"
application.register("booking-wizard-resend", BookingWizardResendController)

import BookingWizardScheduleController from "./booking_wizard_schedule_controller"
application.register("booking-wizard-schedule", BookingWizardScheduleController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CareSegmentsController from "./care_segments_controller"
application.register("care-segments", CareSegmentsController)

import CancellationReasonController from "./cancellation_reason_controller"
application.register("cancellation-reason", CancellationReasonController)

import VisitScheduleController from "./visit_schedule_controller"
application.register("visit-schedule", VisitScheduleController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import EmailLinkFormController from "./email_link_form_controller"
application.register("email-link-form", EmailLinkFormController)

import FormController from "./form_controller"
application.register("form", FormController)

import PasscodeInputController from "./passcode-input-controller"
application.register("passcode-input", PasscodeInputController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import LocationAutocompleteController from "./location_autocomplete_controller"
application.register("location-autocomplete", LocationAutocompleteController)

import LoginMethodController from "./login_method_controller"
application.register("login-method", LoginMethodController)

import MessageFormController from "./message_form_controller"
application.register("message-form", MessageFormController)

import MessagesController from "./messages_controller"
application.register("messages", MessagesController)

import PetFormController from "./pet_form_controller"
application.register("pet-form", PetFormController)

import PhoneDialogController from "./phone_dialog_controller"
application.register("phone-dialog", PhoneDialogController)

import ProviderProfileFormController from "./provider_profile_form_controller"
application.register("provider-profile-form", ProviderProfileFormController)

import ProvidersMapController from "./providers_map_controller"
application.register("providers-map", ProvidersMapController)

import ReferralFormController from "./referral_form_controller"
application.register("referral-form", ReferralFormController)

import ScheduleController from "./schedule_controller"
application.register("schedule", ScheduleController)

import SmsCodeController from "./sms-code-controller"
application.register("sms-code", SmsCodeController)

import TimezoneCookieController from "./timezone_cookie_controller"
application.register("timezone-cookie", TimezoneCookieController)
